export default "__VITE_ASSET__b6e9e0bb__"